module.exports = __webpack_public_path__ + "img/methoden_320.38d4a525.webp";